import makeAsyncScript from "react-async-script";

export default makeAsyncScript("https://accounts.google.com/gsi/client")(
  () => null,
);
